import { useCallback, useEffect, useState } from "react";
import { teammatesApi } from "../api";
import type { TeammateConversation } from "../types/teammates";

export function useTeammateConversations(teammateId: string | null) {
  const [loaded, setLoaded] = useState<{ teammateId: string; items: TeammateConversation[] } | null>(null);

  const reload = useCallback(() => {
    if (!teammateId) return;
    teammatesApi
      .listConversations(teammateId)
      .then((res) => setLoaded({ teammateId, items: Array.isArray(res.data) ? res.data : [] }))
      .catch(() => {});
  }, [teammateId]);

  useEffect(() => {
    reload();
  }, [reload]);

  useEffect(() => {
    window.addEventListener("conversation-updated", reload);
    return () => window.removeEventListener("conversation-updated", reload);
  }, [reload]);

  return loaded && loaded.teammateId === teammateId ? loaded.items : [];
}
